import React, {Component} from "react";
import axios from "axios";
import scrollToElement from "scroll-to-element"
import SweetAlert from 'react-bootstrap-sweetalert';
import {withTranslate} from "react-redux-multilingual";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import globalMiddleware from "../../hocs/globalMiddleware";
import {
    clearBookingInfo,
    clearCurrentDoctor,
    clearReviews,
    getAllDoctorReviews,
    getCurrentBookingFees,
    getDoctorBranchDayBreaks,
    getDoctorBranchDays,
    getDoctorBranchDayTimes,
    getDoctorBranches,
    getDoctorDetails,
} from "../../store/actions/doctorActions"
import Subscribe from "../../components/Subscribe";
import DoctorDetails from "../../components/doctors/DoctorDetails"
import {clearOfferDetails, getOfferDetails} from "../../store/actions/offerActions";
/***************Animation*********************/
import {slideInRight} from 'react-animations';
import Radium from 'radium';

import {
    getAddReservationLink,
    getCurrentBookingFeesLink,
    getHeader,
    rescheduleReservationLink,
    ResendCodeUrl
} from "../../config";
import SingleDoctorSidebar from "../../components/doctors/book/SingleDoctorSidebar";
import DoctorProfileCard from "../../components/doctors/DoctorProfileCard";
import Login from "../../views/auth/Login";
import {changeActivationPopUpStatus, changeAuthPopUpStatus} from "../../store/actions/reservationActions";
import Register from "../../views/auth/Register";
import {authTogglePopUpStatus} from "../../store/actions/userActions";
import {clearError500, setCurrentRoute} from "../../store/actions/globalActions";
import Activate from "../../views/auth/Activate";
import NoMatch from "../../views/NoMatch";
import Maintenance from "../../components/doctors/DoctorsPage";
import {callLightBox, initLightBox} from "../../payment_getway/paysky";


class DoctorProfile extends Component {
    constructor(props) {
        super(props);
        this.token = window.localStorage.getItem('access_token') ? JSON.parse(window.localStorage.getItem('access_token')) : null;
        this.rescheduleReservation = window.localStorage.getItem("rescheduleReservation") ? JSON.parse(window.localStorage.getItem("rescheduleReservation")) : null;
        this.is_active = window.localStorage.getItem('isActive') ? JSON.parse(window.localStorage.getItem('isActive')) : null;
        this.ref = React.createRef();
    }

    state = {
        doctor_unique_id: 0,

        book: 0,
        currentBranch: null,
        currentDay: null,
        currentTime: null,

        currentDaysPageOffset: 0,
        currentDaysPage: 1,
        currentDaysPageLimit: 10,

        currentTimesPageOffset: 0,
        currentTimesPage: 1,
        currentTimesPageLimit: 8,

        currentBookingFeesDetails: null,

        offer: null,

        type: 0,
        complaint: null,
        payment_method: 0,


        calculatingFees: false,
        submittingToServer: false,


        successfullyBooked: false,
        currentReservation: null,

        error: null,
        isPromoSuccess: false,
        promoCodeLoading: false,

        reviewLimit: 3,
        reviewOffset: 0,
        loadMoreLoading: false,

        showScrollBtn: false,

        showOpenAppBtn: false,

        windowOffsetOnScroll: 0,

        fromDoctorRoute: false,

        // sweet alert for login pop up
        showAuthPopUpSweetAlert: false,

        // sweet alert for activation pop up
        showActivationPopUpSweetAlert: false,

        sendCodeErrorMsg: null,
        /*******Error on cancel plan********/
        showErrorCancelSweetAlert: false,

        styles: {
            slideInRight: {
                animation: 'x 1s',
                animationName: Radium.keyframes(slideInRight, 'slideInRight')
            }
        }
    };


    /*** Life Cycle Methods ***/

    /*************************/
    componentWillMount() {
        window.addEventListener("scroll", this.handleOnScroll);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.offerDetails != null && nextProps.offerDetailsIsLoading === false) {
            if (nextProps.offerDetails && nextProps.offerDetails.doctor && nextProps.doctor && (nextProps.offerDetails.doctor.id === nextProps.doctor.id)) {
                this.setState({
                    offer: nextProps.offerDetails
                }, () => {
                    console.log("eman")
                })
            } else {
                window.localStorage.removeItem("offer");
                this.setState({
                    offer: null
                })
            }
        }
    }

    componentDidMount = async () => {
        // init payment API
        this.initPayment();
        this.props.clearError500();
        this.props.clearOfferDetails();
        this.props.authTogglePopUpStatus(false);


        window.addEventListener("click", this.handleWindowOnclick);


        if (this.props.match.path.includes("doctor")) {
            this.setState({
                fromDoctorRoute: true,
            })
        }
        if (this.props.error && this.props.error.desc) {
            let branch = document.getElementsByClassName("branch-fees");
            branch.style.height += "90px";
        }
        window.scrollTo(0, 0);

        this.initPage();
    };

    handleWindowOnclick = (e) => {
        let activationPopUp = document.getElementById("activation-pop-up");
        let authPopUp = document.getElementById("auth-pop-up");

        switch (e.target) {
            case activationPopUp:
                this.props.changeActivationPopUpStatus(false);
                activationPopUp.style.width = "0";
                break;
            case authPopUp:
                this.props.changeAuthPopUpStatus(false);
                authPopUp.style.width = "0";
            default:
                //
        }
    };

    initPage = async () => {
        const id = this.props.match.params.id;
        this.props.clearReviews();
        this.props.clearCurrentDoctor();
        await this.props.getDoctorDetails(id);
        await this.props.getAllDoctorReviews(id, 3, 0);
        await this.props.getDoctorBranches(id);

        if (this.rescheduleReservation && this.rescheduleReservation.clinic) {
            this.book(this.rescheduleReservation.clinic);
        }
    };


    initPayment = () => {
        initLightBox();
        const script = document.createElement("script");
        script.src = "https://grey.paysky.io:9006/invchost/JS/LightBox.js";
        script.async = true;
        document.body.appendChild(script);
    };


    focusOnSidebar = () => {
        let overlay = document.getElementById('page-overlay');
        let sidebar = document.getElementById("doctor-sidebar");
        overlay.style.display = "block";
        sidebar.style.zIndex = "1003";
    };

    closePageOverlay = () => {
        let overlay = document.getElementById('page-overlay');
        overlay.style.display = "none";
    };
    //
    // closest(e, t) {
    //     return !e ? false : e === t ? true : closest(e.parentNode, t);
    // }

    resendCode = () => {
        // start loading
        this.setState({
            resendLoading: true,
        });
        axios.post(ResendCodeUrl, "", {headers: getHeader()}).then(res => {
            // if not success
            if (res.data.Error.code !== 20) {
                this.setState({
                    sendCodeErrorMsg: res.data.Error.desc,
                });
            }

        }).catch(error => {
        })
    };

    changeAuthFormStatus = (e, status) => {
        e.preventDefault();

        if (status === "close") {
            this.props.changeAuthPopUpStatus(false);

            document.getElementById("auth-pop-up").style.width = "0";
        } else {
            this.props.changeAuthPopUpStatus(true);

            document.getElementById("auth-pop-up").style.width = window.innerWidth + "px";
            document.getElementById("auth-pop-up").style.height = window.innerHeight + "px";
        }
    };

    changeActivationFormStatus = (e, status) => {
        if (e) {
            e.preventDefault();
        }

        if (status === "close") {
            this.props.changeActivationPopUpStatus(false);
            document.getElementById("activation-pop-up").style.width = "0";
        } else {
            this.props.changeActivationPopUpStatus(true);
            document.getElementById("activation-pop-up").style.width = window.innerWidth + "px";
            document.getElementById("activation-pop-up").style.height = window.innerHeight + "px";
        }
    };

    onConfirmAuthPopUpSweetAlert = (e) => {
        this.setState({
            showAuthPopUpSweetAlert: false,
        }, () => {
            document.getElementById("auth-pop-up").style.width = window.innerWidth + "px";
            document.getElementById("auth-pop-up").style.height = window.innerHeight + "px";
            this.props.changeAuthPopUpStatus(true);
        })
    };

    onConfirmActivationPopUpSweetAlert = async (e) => {
        await this.setState({
            sendCodeErrorMsg: null,
        });
        this.resendCode();
        this.setState({
            showActivationPopUpSweetAlert: false,
        }, () => this.changeActivationFormStatus(e, "open"))
    };

    handleScrollToReviews = (e) => {
        e.preventDefault();
        const reviews = document.getElementById('reviews');
        reviews.scrollIntoView({
            behavior: "smooth"
        })

    };

    goToSidebar = (e) => {
        e.preventDefault();
        const doctorSidebar = document.getElementById('doctor-sidebar');
        scrollToElement(doctorSidebar, {
            offset: -65,
            ease: 'out-sine',
            duration: 250
        });

    }

    handleOnScroll = () => {
        let width = window.innerWidth || document.body.clientWidth;
        let isMobile = /iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone|Android/i.test(navigator.userAgent);
        let doc = document.documentElement;
        let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (isMobile && width < 768 && top > 10) {
            this.setState({
                showScrollBtn: true,
            })
        } else {
            this.setState({
                showScrollBtn: false,
            })
        }
    };
    /*
    * When a user clicks on book for a specific branch.
    *
    * */


    book = async (branch) => {
        let width = window.innerWidth || document.body.clientWidth;
        let isMobile = /iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone|Android/i.test(navigator.userAgent);
        if (isMobile && width < 768) {
            const doctorSidebar = document.getElementById('doctor-sidebar');
            if (doctorSidebar) {
                scrollToElement(doctorSidebar, {
                    offset: -65,
                    ease: 'out-sine',
                    duration: 500
                });
            }
        }
        await this.getCachedOffer();
        // reset all settings
        this.cancelBooking();

        await this.props.getDoctorBranchDays(branch);
        this.setState({
            currentBranch: branch,
            currentDay: null,
            currentTime: null,
        });
    };

    /*
     *  Resets all booking data
     *  */
    cancelBooking = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            currentBranch: null,
            currentDay: null,
            calculatingFees: false,
            submittingToServer: false,
            error: null,
            currentBookingFeesDetails: null,
        });

        this.props.clearBookingInfo();
    };

    setCurrentDay = async (day, e) => {
        e.currentTarget.classList.add("active");
        const siblings = this.getSiblings(e.currentTarget);

        siblings.forEach(sibling => {
            sibling.classList.remove("active");
        });

        this.setState({
            currentDay: day,
            currentTime: null,
            currentTimesPageOffset: 0,
            currentTimesPage: 1,
            currentTimesPageLimit: 8,
        });

        if (this.state.currentBranch && this.state.currentBranch.pattern === 1) {
            this.getDayBreaks(day, this.state.currentBranch.id);
        } else {
            await this.getDayTimes(day, this.state.currentBranch.id);
            this.setState({
                currentTimesTotal: this.props.currentBranchDayTimes ? this.props.currentBranchDayTimes.length : this.state.currentTimesTotal,
            })
        }
    };
    getDayTimes = (day, clinic_id) => {
        this.props.getDoctorBranchDayTimes(day, clinic_id);
    };

    setCurrentTime = (time, e) => {
        e.currentTarget.classList.add("active");
        const siblings = this.getSiblings(e.currentTarget);

        siblings.forEach(sibling => {
            sibling.classList.remove("active");
        });


        this.setState({
            currentTime: time
        });
    };

    getDayBreaks = (day, clinic_id) => {
        this.props.getDoctorBranchDayBreaks(day, clinic_id);
    };

    getSiblings = (elem) => {
        // Setup siblings array and get the first sibling
        let siblings = [];
        let sibling = elem.parentNode.firstChild;

        // Loop through each sibling and push to the array
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== elem) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling
        }

        return siblings;
    };

    setNextTimesPage = () => {
        const {currentTimesPage, currentTimesPageLimit} = this.state;
        const lastPage = Math.round(this.props.currentBranchDayTimesLimit / currentTimesPageLimit) + 1;


        let newOffset = currentTimesPage * currentTimesPageLimit;
        let newPage = currentTimesPage + 1;


        this.setState({
            currentTimesPageOffset: newOffset >= this.props.currentBranchDayTimesLimit ? this.state.currentTimesPageOffset : this.state.currentTimesPageOffset + this.state.currentTimesPageLimit,
            currentTimesPage: currentTimesPage >= lastPage ? currentTimesPage : newPage,
        })
    };

    setPreviousTimesPage = () => {
        const {currentTimesPageOffset, currentTimesPage, currentTimesPageLimit} = this.state;
        //  const lastPage = Math.round(this.props.currentBranchDayTimesLimit / currentTimesPageLimit) + 1;


        let newOffset = currentTimesPageOffset - currentTimesPageLimit;
        let newPage = currentTimesPage - 1;


        this.setState({
            currentTimesPageOffset: currentTimesPageOffset === 0 ? currentTimesPageOffset : newOffset,
            currentTimesPage: currentTimesPage === 1 ? currentTimesPage : newPage,
        })
    };

    getCachedOffer = async () => {
        const cachedOffer = window.localStorage.getItem("offer");

        if (cachedOffer) {
            const offer = JSON.parse(cachedOffer);
            /*if (this.props.offerDetails) {
                this.props.clearOfferDetails();
            }
    */
            await this.props.getOfferDetails(offer.id);

        }
    }

    handleFieldOnChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    };

    submitRescheduleReservation = () => {
        let width = window.innerWidth || document.body.clientWidth;
        let isMobile = /iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone|Android/i.test(navigator.userAgent);
        const doctorSidebar = document.getElementById('doctor-sidebar');

        this.setState({
            submittingToServer: true,
            error: null,
            calculatingFees: true,
        });
        if (this.rescheduleReservation) {
            // const token = window.localStorage.getItem("access_token");
            if (!this.token) {
                this.setState({
                    showAuthPopUpSweetAlert: true,
                })
            } else {
                if (this.is_active === 0) {
                    this.setState({
                        showActivationPopUpSweetAlert: true,
                    })
                } else {
                    if (isMobile && width < 768) {
                        if (doctorSidebar) {
                            scrollToElement(doctorSidebar, {
                                offset: -65,
                                ease: 'out-sine',
                                duration: 500
                            });
                        }
                    }
                    this.setState({
                        error: null
                    });

                    let data = {
                        reservation_id: this.rescheduleReservation.id,
                        day: this.state.currentDay ? this.state.currentDay.date : null,
                        working_hour_id: this.state.currentTime ? this.state.currentTime.id : null,
                    };
                    axios.post(rescheduleReservationLink, data, {headers: getHeader()}).then(res => {
                        this.setState({
                            calculatingFees: false,
                        });
                        if (res.data.Error.code === 20) {
                            this.setState({
                                submittingToServer: false,
                                successfullyBooked: true,
                                currentReservation: res.data.Response,
                            });
                            window.localStorage.removeItem("rescheduleReservation")
                            //this.getCurrentReservationDetails(res.data.Response.id)
                        } else {
                            this.setState({
                                error: res.data.Error,
                                calculatingFees: false,
                                submittingToServer: false,
                            });
                        }


                    }).catch(err => {
                        this.setState({
                            submittingToServer: false,
                            calculatingFees: false,
                        });
                    })
                }
            }
        } else {
            this.setState({
                error: {
                    desc: this.props.translate('something_wrong'),
                }
            });
        }
    }

    getBookingFees = (e, services, promoCode = -1) => {

        let width = window.innerWidth || document.body.clientWidth;
        let isMobile = /iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone|Android/i.test(navigator.userAgent);
        const doctorSidebar = document.getElementById('doctor-sidebar');


        let cachedData = {
            doctor_unique_id: this.props.match.params.id,
            type: this.state.type,
            currentBranch: this.state.currentBranch,
            currentDay: this.state.currentDay,
            currentTime: this.state.currentTime,
        };
        if (this.state.offer) {
            cachedData.offer = this.state.offer
        }

        if (!this.props.authUser) {
            // localStorage.setItem("reservation", JSON.stringify(cachedData));
            // this.changeAuthFormStatus(e, "open");
            // this.props.changeAuthPopUpStatus(true);
            this.setState({
                showAuthPopUpSweetAlert: true,
            })
        } else {
            if (isMobile && width < 768) {
                if (doctorSidebar) {
                    scrollToElement(doctorSidebar, {
                        offset: -65,
                        ease: 'out-sine',
                        duration: 500
                    });
                }
            }
            if (this.rescheduleReservation) {
                this.setState({
                    currentBookingFeesDetails: true,
                })
            }

            if (promoCode === -1) {
                this.setState({
                    calculatingFees: true,
                })
            } else {
                this.setState({
                    promoCodeLoading: true,
                })
            }

            let data = {
                clinic_id: this.state.currentBranch.id,
                type: this.state.type,
                "promo-code": promoCode
            };
            if (this.state.offer) {
                data.offer_id = this.state.offer.id
            }
            if (services) {
                data.services = services;
            }
            axios.post(getCurrentBookingFeesLink, data, {headers: getHeader()}).then(res => {
                if (promoCode === -1) {
                    this.setState({
                        calculatingFees: false,
                    })
                } else {
                    this.setState({
                        promoCodeLoading: false,
                    })
                }
                const error = res.data.Error;

                if (res.data.Error.status === true) {
                    const currentBookingFeesDetails = res.data.Response;
                    this.setState({
                        currentBookingFeesDetails: currentBookingFeesDetails,
                        isPromoSuccess: true,
                        error: error
                    });
                    // window.scrollTo(100, 100);
                } else {
                    this.setState({
                        isPromoSuccess: false,
                        error: error
                    });
                }
            }).catch(err => {
                this.setState({
                    error: err,
                });
                if (promoCode === -1) {
                    this.setState({
                        calculatingFees: false,
                    })
                } else {
                    this.setState({
                        promoCodeLoading: false,
                    })
                }
            });
            //this.props.getCurrentBookingFees(this.state.currentBranch, this.state.offer, this.state.type);
            //window.scrollTo(100, 100);
        }
    };
    checkDisabled = (currentBranch) => {
        if (currentBranch.pattern === 0) {
            return !(this.state.currentDay && this.state.currentTime);
        } else {
            return !this.state.currentDay;
        }

    };

    handleSubmitReservation = (payment, promoCode, services) => {
        this.setState({
            submittingToServer: true,
            error: null
        });

        // if payment online
        // show popup
        this.submitReservationToServer(
            this.state.currentBranch.id,
            this.state.currentDay ? this.state.currentDay.date : null,
            this.state.currentTime ? this.state.currentTime.id : null,
            0,
            this.state.complaint, payment ? payment.payment_method : 0, null, this.state.offer ? this.state.offer.id : null,
            this.state.currentBookingFeesDetails && this.state.currentBookingFeesDetails.promo_msg ? promoCode : "", services ? services : []);
    };


    submitReservationToServer = (clinic_id, day, working_hour_id = null, type = 0, complaint = null, payment_method, reservation_id = null, offer_id = null, promoCode, services) => {
        this.setState({
            error: null
        });
        let serverData = {
            clinic_id: clinic_id,
            day: day,
            type: type,
            payment_method: payment_method,
            "promo-code": promoCode,
            services: !services || !services.length ? [] : JSON.parse(services),
        };
        if (working_hour_id) {
            serverData.working_hour_id = working_hour_id
        }
        if (complaint) {
            serverData.complaint = complaint
        }
        if (reservation_id) {
            serverData.reservation_id = reservation_id
        }
        if (offer_id) {
            serverData.offer_id = offer_id
        }

        if (payment_method === 1 || payment_method === 2) {
            callLightBox(this.state.currentBookingFeesDetails.total_fees
                , this.props.authUser.unique_id, (data) => {
                    serverData.transaction_id = data.SystemReference
                    this.submitReservationToReserveAxios(serverData)
                }, () => {
                    this.setState({
                        showErrorCancelSweetAlert: true
                    })
                }, () => {
                    this.setState({
                        submittingToServer: false
                    })
                }
            );
        } else {
            this.submitReservationToReserveAxios(serverData)
        }


    };
    submitReservationToReserveAxios = (data) => {

        axios.post(getAddReservationLink, data, {headers: getHeader()}).then(res => {

            if (res.data.Error.code === 20) {
                this.setState({
                    submittingToServer: false,
                    successfullyBooked: true,
                    currentReservation: res.data.Response,
                });


                //this.getCurrentReservationDetails(res.data.Response.id)
            } else {
                if (res.data.Error.code === 27) {
                    this.setState({
                        showActivationPopUpSweetAlert: true,
                    })
                } else {
                    this.setState({
                        error: res.data.Error,
                        calculatingFees: false,
                        submittingToServer: false,
                    });
                }
            }
        }).catch(err => {
            this.setState({
                submittingToServer: false,
            });
        })
    }
    /*getCurrentReservationDetails = (id) => {
        this.setState({
            currentReservationDetailsIsLoading: false,
            error: null
        });
        axios.post(getCurrentReservationDetails, {reservation_id: id}, {headers: getHeader()}).then(res => {

            this.setState({
                currentReservationDetailsIsLoading: false,
            });
            if (res.data.Error.code === 20) {
                this.setState({
                    currentReservation: res.data.Response ? res.data.Response : null,
                });
            } else {
                this.setState({
                    error: res.data.Error,
                    calculatingFees: false,
                    submittingToServer: false,
                });
            }
        }).catch(err => {
            this.setState({
                currentReservationDetailsIsLoading: false,
            });
        })
    };*/

    resetBooking = () => {
        this.setState({
            book: 0,
            currentBranch: null,
            currentDay: null,
            currentTime: null,

            currentDaysPageOffset: 0,
            currentDaysPage: 1,
            currentDaysPageLimit: 10,

            currentTimesPageOffset: 0,
            currentTimesPage: 1,
            currentTimesPageLimit: 8,

            offer: null,

            type: 0,
            complaint: null,
            payment_method: 0,

            calculatingFees: false,
            submittingToServer: false,

            successfullyBooked: false,
            currentReservation: null,

        })
    };

    removeOfferCache = (e) => {
        e.preventDefault();
        this.props.clearOfferDetails();
        window.localStorage.removeItem("offer");
        this.setState({
            offer: null
        })
    };

    loadMoreReviews = (e, limit, offset) => {
        e.preventDefault();
        const id = this.props.match.params.id;

        this.setState({
                reviewOffset: this.state.reviewOffset + 3
            },
            () => {
                this.props.getAllDoctorReviews(id, this.state.reviewLimit, this.state.reviewOffset);
            }
        )
    };

    closeOpenAppBtn = (e) => {
        e.preventDefault();
        this.setState({
            showOpenAppBtn: true,
        })
    };

    render() {
        if (this.props.error500) {
            return (
                <Maintenance/>
            )
        }

        if (this.props.currentDoctorNotFound) {
            return <NoMatch/>
        }

        const {doctor, branches, branchesIsLoading, currentBranchDays} = this.props;
        return (
            <div className="doctors-details-card" id="doctor-profile">
                <section className="doctors-details">

                    {this.state.showScrollBtn ?
                        <div>
                            <div className="scroll-btn" onClick={(e) => this.goToSidebar(e)}>
                                <button
                                    className="btn-style-less white bolder font-18"> {this.props.translate('book_now')}</button>
                            </div>
                            <div className="open-app-btn" hidden={this.state.showOpenAppBtn}>
                                <a href="http://onelink.to/cbd2f2">
                                    <button
                                        className="btn-style-less white bolder font-18"> {this.props.translate('open_app')}</button>
                                    <span className="white-right-hr"></span>
                                </a><span onClick={(e) => this.closeOpenAppBtn(e)}><i
                                className="fas fa-times white bolder cursor-pointer"
                            ></i></span></div>
                        </div> : null}

                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="doctor-profile-card-area">
                                    <DoctorProfileCard language={this.props.language}
                                                       doctor={doctor}
                                                       authUser={this.props.authUser}
                                                       handleScrollToReviews={(e) => this.handleScrollToReviews(e)}
                                                       currentDoctorIsLoading={this.props.currentDoctorIsLoading}/>
                                    <SingleDoctorSidebar
                                        closePageOverlay={(e) => this.closePageOverlay(e)}
                                        focusOnSidebar={(e) => this.focusOnSidebar(e)}
                                        language={this.props.language}
                                        authUser={this.props.authUser}
                                        currentDoctorIsLoading={this.props.currentDoctorIsLoading}
                                        offer={this.state.offer}
                                        branches={branches}
                                        branchesIsLoading={branchesIsLoading}
                                        currentBranchDays={currentBranchDays}
                                        currentBranchDayTimesIsLoading={this.props.currentBranchDayTimesIsLoading}
                                        currentBranchDayTimes={this.props.currentBranchDayTimes}
                                        currentTimesPage={this.state.currentTimesPage}
                                        currentDay={this.state.currentDay}
                                        styles={this.state.styles}
                                        currentBranch={this.state.currentBranch}
                                        currentBranchDayBreaks={this.props.currentBranchDayBreaks}
                                        currentBranchDayBreaksIsLoading={this.props.currentBranchDayBreaksIsLoading}
                                        currentBookingFeesDetails={this.state.currentBookingFeesDetails}
                                        cancelBooking={(e) => this.cancelBooking(e)}
                                        isPromoSuccess={this.state.isPromoSuccess}
                                        promoCodeLoading={this.state.promoCodeLoading}
                                        error={this.state.error}
                                        calculatingFees={this.state.calculatingFees}
                                        book={(currentBranch) => this.book(currentBranch)}
                                        setCurrentDay={(day, e) => this.setCurrentDay(day, e)}
                                        translate={this.props.translate}
                                        currentBranchDayTimesLimit={this.props.currentBranchDayTimesLimit}
                                        currentBranchDaysIsLoading={this.props.currentBranchDaysIsLoading}
                                        currentTime={this.state.currentTime}
                                        setCurrentTime={(time, e) => this.setCurrentTime(time, e)}
                                        currentTimesPageLimit={this.state.currentTimesPageLimit}
                                        currentTimesPageOffset={this.state.currentTimesPageOffset}
                                        setPreviousTimesPage={() => this.setPreviousTimesPage()}
                                        setNextTimesPage={() => this.setNextTimesPage()}
                                        handleFieldOnChange={(e) => this.handleFieldOnChange(e)}
                                        getBookingFees={(e, services, promoCode) => this.getBookingFees(e, services, promoCode)}
                                        checkDisabled={(currentBranch) => this.checkDisabled(currentBranch)}
                                        handleSubmitReservation={(payment, promoCode, services) => this.handleSubmitReservation(payment, promoCode, services)}
                                        submitRescheduleReservation={() => this.submitRescheduleReservation()}
                                        cachedRescheduleReservation={this.rescheduleReservation}
                                        submittingToServer={this.state.submittingToServer}
                                        currentReservation={this.state.currentReservation}
                                        resetBooking={() => this.resetBooking()}
                                        doctor={this.props.doctor}
                                        removeOfferCache={(e) => this.removeOfferCache(e)}
                                        successfullyBooked={this.state.successfullyBooked}
                                        offerDetailsIsLoading={this.props.offerDetailsIsLoading}/>

                                    <DoctorDetails language={this.props.language}
                                                   currentDoctorIsLoading={this.props.currentDoctorIsLoading}
                                                   doctor={doctor}
                                                   toggleShowMore={(e, num, stateVariable, collapsePropsLength) => this.props.toggleShowMore(e, num, stateVariable, collapsePropsLength)}
                                                   numOfServices={this.props.numOfServices}
                                                   numOfIncCompanies={this.props.numOfIncCompanies}
                                                   doctorReviews={this.props.doctorReviews}
                                                   noMoreReviews={this.props.noMoreReviews}
                                                   reviewsLoading={this.props.reviewsLoading}
                                                   loadMoreReviews={(e, limit, offset) => this.loadMoreReviews(e, limit, offset)}/>
                                </div>

                                <div hidden={this.props.authPopUpStatus === false} className="pop-up"
                                     id="auth-pop-up">
                                    <div className="flex-align-center" hidden={this.props.authToggleFormStatus}>
                                        <Login
                                            changeAuthFormStatus={(e, status) => this.changeAuthFormStatus(e, status)}/>
                                    </div>
                                    <div className="flex-align-center" hidden={!this.props.authToggleFormStatus}>
                                        <Register
                                            changeAuthFormStatus={(e, status) => this.changeAuthFormStatus(e, status)}/>
                                    </div>
                                </div>
                                <div hidden={this.props.activationPopUpStatus === false}
                                     className="pop-up" id="activation-pop-up">
                                    <div className="flex-align-center" hidden={this.props.authToggleFormStatus}>
                                        <Activate sendCodeErrorMsg={this.state.sendCodeErrorMsg}
                                                  changeActivationFormStatus={(e, status) => this.changeActivationFormStatus(e, status)}/>
                                    </div>
                                </div>
                                <div id="page-overlay"></div>
                                <SweetAlert
                                    show={this.state.showAuthPopUpSweetAlert}
                                    title={this.props.translate('auth_pop_up_sweet_alert_title')}
                                    onConfirm={(e) => this.onConfirmAuthPopUpSweetAlert(e)}
                                    confirmBtnText={this.props.translate('login')}
                                    showCancel
                                    warning
                                    cancelBtnBsStyle="sweet custom-danger"
                                    confirmBtnBsStyle="sweet success-sweet"
                                    onCancel={() => this.setState({showAuthPopUpSweetAlert: false})}>
                                    {this.props.translate('auth_pop_up_sweet_alert_text')}
                                </SweetAlert>
                                <SweetAlert
                                    show={this.state.showActivationPopUpSweetAlert}
                                    title={this.props.translate('activation_pop_up_sweet_alert_title')}
                                    onConfirm={(e) => this.onConfirmActivationPopUpSweetAlert(e)}
                                    confirmBtnText={this.props.translate('active')}
                                    showCancel
                                    warning
                                    cancelBtnBsStyle="sweet custom-danger"
                                    confirmBtnBsStyle="sweet success-sweet"
                                    onCancel={() => this.setState({showActivationPopUpSweetAlert: false})}>
                                    {this.props.translate('activation_pop_up_sweet_alert_text')}
                                </SweetAlert>
                                {/***************************ErrorCancelPlanSweetAlert *******************************/}
                                <SweetAlert
                                    show={this.state.showErrorCancelSweetAlert}
                                    title={this.props.translate("error")}
                                    warning
                                    confirmBtnBsStyle="sweet success-sweet"
                                    onConfirm={() => this.setState({showErrorCancelSweetAlert: false})}
                                    confirmBtnText={this.props.translate("ok")}>
                                    {this.props.translate("something_wrong")}
                                </SweetAlert>
                            </div>
                        </div>
                    </div>

                </section>
                <Subscribe/>
            </div>
        )
    }
}


const
    mapStateToProps = (state) => {
        return {
            doctor: state.doctor.current,
            currentDoctorNotFound: state.doctor.currentDoctorNotFound,
            currentDoctorIsLoading: state.doctor.currentDoctorIsLoading,
            branches: state.doctor.branches,
            branchesIsLoading: state.doctor.branchesIsLoading,
            currentBranch: state.doctor.currentBranch,
            currentBranchDays: state.doctor.currentBranchDays,
            currentBranchDaysLimit: state.doctor.currentBranchDaysLimit,
            currentBranchDaysIsLoading: state.doctor.currentBranchDaysIsLoading,
            currentBranchDayTimes: state.doctor.currentBranchDayTimes,
            currentBranchDayTimesIsLoading: state.doctor.currentBranchDayTimesIsLoading,
            currentBranchDayTimesLimit: state.doctor.currentBranchDayTimesLimit,
            currentBranchDayBreaks: state.doctor.currentBranchDayBreaks,
            currentBranchDayBreaksIsLoading: state.doctor.currentBranchDayBreaksIsLoading,
            currentBookingFees: state.doctor.currentBookingFees,
            currentBookingFeesIsLoading: state.doctor.currentBookingFeesIsLoading,
            currentBookingErrors: state.doctor.currentBookingErrors,
            doctorReviews: state.doctor.doctorReviews,
            reviewsLoading: state.doctor.reviewsLoading,
            noMoreReviews: state.doctor.noMoreReviews,
            goToDoctorProfileFromBooking: state.doctor.goToDoctorProfileFromBooking,
            // for show/hide activation pop up
            activationPopUpStatus: state.reservation.activationPopUpStatus,
            // for show/hide auth pop up
            authPopUpStatus: state.reservation.authPopUpStatus,
            //for show login or register
            authToggleFormStatus: state.user.authToggleFormStatus,

            //cached offer
            offerDetails: state.offer.offerDetails,
            offerDetailsIsLoading: state.offer.offerDetailsIsLoading,
            error500: state.global.error500,
        }
    };


const
    mapDispatchToProps = (dispatch) => {
        return {
            getDoctorDetails: (id) => dispatch(getDoctorDetails(id)),
            clearCurrentDoctor: () => dispatch(clearCurrentDoctor()),
            getDoctorBranches: (id) => dispatch(getDoctorBranches(id)),
            getDoctorBranchDays: (branch) => dispatch(getDoctorBranchDays(branch)),
            getDoctorBranchDayTimes: (day, clinic_id) => dispatch(getDoctorBranchDayTimes(day, clinic_id)),
            getDoctorBranchDayBreaks: (day, clinic_id) => dispatch(getDoctorBranchDayBreaks(day, clinic_id)),
            getCurrentBookingFees: (clinic_id, offer_id, type, services) => dispatch(getCurrentBookingFees(clinic_id, offer_id, type, services)),
            clearBookingInfo: () => dispatch(clearBookingInfo()),
            getAllDoctorReviews: (unique_id, limit, offset) => dispatch(getAllDoctorReviews(unique_id, limit, offset)),
            clearReviews: () => dispatch(clearReviews()),
            // for show/hide activation pop up
            changeActivationPopUpStatus: (status) => dispatch(changeActivationPopUpStatus(status)),
            // for show/hide auth pop up
            changeAuthPopUpStatus: (status) => dispatch(changeAuthPopUpStatus(status)),
            //for show login or register
            authTogglePopUpStatus: (status) => dispatch(authTogglePopUpStatus(status)),
            // to get details for cached offer
            getOfferDetails: (offer_id) => dispatch(getOfferDetails(offer_id)),
            clearOfferDetails: () => dispatch(clearOfferDetails()),
            clearError500: () => dispatch(clearError500())

        }
    };
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(globalMiddleware(DoctorProfile))))